module.exports = __webpack_public_path__ + "img/arrow-narrow-right-black.227e92cb.svg";